import { z } from "zod";

const CountryObjectSchema = z.object({
	id: z.number(),
	name: z.string(),
	code: z.string(),
	calling_code: z.string(),
	mobile_number_length: z.number(),
});

export const CountryListSchema = z.object({
	countries: z.array(CountryObjectSchema),
});
export type Country = z.infer<typeof CountryObjectSchema>;

export type CountryList = z.infer<typeof CountryListSchema>;
